import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../../../components/Layout/Layout';
import {SaasService } from '../../../services/saas/saasService';
import './index.css';
import { useSelector } from 'react-redux';
import { UserState } from '../../../store/reducers/userReducer';
import { RootState } from '../../../store/index';
import LCDashboard, { Card } from '../../../components/Data/Dashboard/LCDashboard';
import PivotTableWebix from '../../../components/webix';
import { OneDrveUsageChart } from './OneDriveUsageChart';
import { EmailBoxesChart } from './EmailBoxesChart';
import { ActiveUsersPerDayChart } from './ActiveUsersPerDayChart';
import { SaasEmailActivitiesChart } from './SaasEmailActivitiesChart';
import LcLoading from '../../../components/Generic/LcLoading';
import { CustomNavPanel, itemsProps } from '../../../components/Layout/CustomNavPanel';
import teamsLogo from '../../../assets/icons/teams-logo.svg'
import onedriveLogo from '../../../assets/icons/onedrive-logo.svg';
import exchangeLogo from '../../../assets/icons/exchange-logo.svg';
import sharepointLogo from '../../../assets/icons/sharepoint-logo.svg';
import panelIcon from '../../../assets/icons/icon-panel-color.svg';
import formsLogo from '../../../assets/icons/forms.png';
import copilotLogo from '../../../assets/icons/copilot.png';
import vivaLogo from '../../../assets/icons/viva.png';
import AIxChatComponent from '../../../components/aix/ChatClient/AIxChatComponent';
import LcIconLink from '../../../components/Generic/LcIconLink';
import { useUserActivityDetails } from './Hook/UseUserActiveDetailsApps';
import { pivotConfigs } from './PivotAppsConfig';
import MessageService from '../../../services/AIx/messages/MessageService';
import LcNoData from '../../../components/Generic/LcNoData';


// const questions = [
//     "Quais produtos [Usuario] possui subscrições atribuídas?",
//     "Qual a data da última atividade no VIva de [NOME_USUARIO]?",
//     "Qual usuário com maior quantidae de chamadas de vídeo?",
//     "Qual usuário possui maior número de emails enviados e recebidos?",
//     "Quais usuários fazem mais uso do Copilot?",
//     "Qual usuári de maior armazenamento Onedrive?"
// ];
const SaaSAtividades: React.FC = () => {
    const local = document.location.pathname;
    const user = useSelector<RootState, UserState>(state => state.user);
    const userPeriodSelected = user.PeriodSelection ? user.PeriodSelection[local] : undefined;
    const [pivotView, setPivotView] = useState<boolean>(false);
    const [pivotFields, setPivotFileds] = useState<any[]>([])
    const [pivotStructure, setPivotStructure] = useState<any>({})
    const [userPeriod, setUserPeriod] = useState<string>(userPeriodSelected ? userPeriodSelected.fields[0].value : '7');
    const [focusedClick, setFocusedClick] =useState<boolean>(false);
    const [focusedPivotData, setFocusedPivotData] = useState<any[]>([])
    const [focusedPivotTitle, setFocusedPivotTitle] = useState<string>("")
    const [pivotName, setPivotName] = useState<boolean>(false);
    const [selectedView, setSelectedView] = useState<string>("table");
    const [painelFocus, setPanelFocus] = useState<boolean>(false);
    const [defaultClickPanel, serDefaultClickPanel] = useState<string>("Painel");
    // const [AIXAgentVisible, setAIXAgentVisible] = useState<boolean>(true);
    // const [loadingAIAssistant, setLoadingAIAssistant] = useState<boolean>(false);
    // const [assistantId, setAssistantId] = useState<string>("");
    // const [pinnedAIPanel, setPinnedAIPanel] = useState<boolean>(true);
    // const [loadingAIData, setLoadingAIData] = useState<boolean>(false);
    const periodSelection = {
        periods: [
            {
                label: 'Últimos 7 dias', text: 'Últimos 7 dias',
                fields: [
                    { name: 'last7Days', value: '7' },
                ],
                default: true
            },
            {
                label: 'Últimos 30 dias', text: 'Últimos 30 dias',
                fields: [
                    { name: 'last30Days', value: '30' }
                ],
                default: false
            },
            {
                label: 'Últimos 3 meses', text: 'Últimos 3 meses',
                fields: [
                    { name: 'last90Days', value: '90' }
                ],
                default: false
            },
            {
                label: 'Últimos 6 meses', text: 'Últimos 6 meses',
                fields: [
                    { name: 'last180Days', value: '180' }
                ],
                default: false
            },
        ],
        customPeriodType: 'month',
        onChange: (selected) => { setUserPeriod(selected.fields[0].value) }
    };

    const appsList: itemsProps[] = [
        { name: "Painel", icon: panelIcon, hidden: false, CustomOnclick:() => {
            setPanelFocus(false)
        }},
        { name: "Teams", icon: teamsLogo,hidden: false},
        // { name: "Copilot", icon: copilotLogo },
        { name: "Exchange", icon: exchangeLogo, hidden: false },
        { name: "OneDrive", icon: onedriveLogo,hidden: false },
        { name: "SharePoint", icon: sharepointLogo, hidden: false },
        // { name: "Forms", icon: formsLogo },
        // { name: "Viva", icon: vivaLogo }
    ];

    const {
        teamsDetail,
        sharePointDetail,
        emailDetail,
        oneDriveDetail,
        loading,
    } = useUserActivityDetails(userPeriod);

    const detailsMap = useMemo(() => ({
        OneDrive: oneDriveDetail,
        Exchange: emailDetail,
        SharePoint: sharePointDetail,
        Teams: teamsDetail,
    }), [oneDriveDetail, emailDetail, sharePointDetail, teamsDetail]);

//ToDO quando tiver o assitente de saas atividades
    // const getAssitantData = async () => {
    //     if (user && user.ClientGroupSelected) {
    //         const messageService = new MessageService({});
    //         var assistantid = await messageService.getAssistantId("17", user.ClientGroupSelected?.toString(), "1");
    //         setAssistantId(assistantid);
    //     }
    // }
    // const dashboardRightPanelAI = {
    //     title: 'LiveCloud AI',
    //     titleClass: 'ai-gradient-text',
    //     pinned: true,
    //     hiddenPin: false,
    //     show: AIXAgentVisible,
    //     focusable: true,
    //     onclose:(e)=> setAIXAgentVisible(e),
    //     togglePinned: () => setPinnedAIPanel(!pinnedAIPanel),
    //     content: () => (
    //         <LcLoading loading={loadingAIData || loadingAIAssistant}>
    //             <div style={{ alignSelf: 'center' }}>
    //                 <AIxChatComponent questions={questions} eventChat={(_event) => { }} assistantId={assistantId} assistantName={"SaasAtividades"} />
    //             </div>
    //         </LcLoading>
    //     ),
    // }
    
    // const layoutFunctions = [{
    //     icon: (
    //         <LcIconLink
    //             icon='ppi ppi-lightning-bolt'
    //             id='aiLCChamados'
    //             size='small'
    //             degrade
    //             tooltip="LiveWatch AI"
    //             tooltipPosition="right"
    //         />
    //     ),
    //     onClick: () => !loadingAIAssistant && setAIXAgentVisible(!AIXAgentVisible),
    //     tooltip: "LiveWatch AI"
    // }]


    //#endregion
    useEffect(() => {
        if (focusedPivotTitle === "") return;
        const updatedData = detailsMap[focusedPivotTitle];
        setFocusedPivotData(updatedData);
    }, [detailsMap, focusedPivotTitle, focusedClick]);

    const handleClickItem = (item: any) => {
            const config = pivotConfigs[item.name];
            if (!config) return;
            setFocusedClick(true);
            setFocusedPivotTitle(item.name);
            setPivotName(item.name);
            const data = detailsMap[item.name];
            setFocusedPivotData(data);
            setPivotFileds(config.fields);
            setPivotStructure(config.structure);
            setPanelFocus(true)
            serDefaultClickPanel(item.name)
        } 
    const principalCards: Card[] = [
        {
            id: 2,
            type: 'Custom',
            showFocusButton: pivotView,
            position: { ColSpan: 9, RowSpan: 7, row: 1, col: 1 },
            title: () => <>{
                <div className="lc-title ellipsis" title="Usuários ativos / dia"> {pivotView ? focusedPivotTitle : "Usuários ativos / dia"}</div>
            }</>
            ,
            customContentRender: (focused: boolean, handleFocusClick: Function) => {
                setPivotView(focused);
                focusedClick && !focused && handleFocusClick();
                if (focused) {
                    setFocusedClick(false)
                    painelFocus === false && handleFocusClick()

                    return(
                        <LcLoading loading={loading}>
                        {
                            focusedPivotData && focusedPivotData.length > 0 ?   
                            <PivotTableWebix
                                focusedStyleVision
                                classTable={selectedView === 'table' ? 'saasActivitiesTable': ''}
                                setViewMode={setSelectedView}
                                mode={selectedView}
                                notFrezeCollumns={selectedView === 'table'}
                                idView={`dataPivot_${pivotName} `}
                                key={`dataPivot_${pivotName} `}
                                data={focusedPivotData}
                                style={{ marginTop: '-10px', width: '100%' }}
                                fields={pivotFields}
                                structure={pivotStructure}
                                footer={false}
                                autoAjustColumns
                                withoutBorder
                                showAllNumbersAsInteger
                            />
                            :
                            <LcNoData/>
                        }
                        </LcLoading>
                    )
                }
                else {
                    if (!focusedClick){
                        setPanelFocus(false)
                        serDefaultClickPanel("Painel")
                    }
                    return <ActiveUsersPerDayChart userPeriod={Number(userPeriod)} />;
                }
            }
        },
        //Atividades de e-mail
        {
            id: 3, type: 'Custom',
            showFocusButton: false,
            position: {
                ColSpan: 3, RowSpan: 5, row: 8, col:1
            },
            title: () => <>{
                <div className="lc-title ellipsis" title="Atividades de e-mail">Atividades de e-mail</div>
            }</>
            , customContentRender: () => {
                    return <SaasEmailActivitiesChart userPeriod={Number(userPeriod)} />
            }
        },
        // //OneDrive ativas / uso
        {
            id: 4, type: 'Custom',
            showFocusButton: false,
            position: {
                ColSpan: 3, RowSpan: 5, row: 8, col: 4
            },
            title: () => <>{
                <div className="lc-title ellipsis" title="OneDrive ativas / uso">Atividades de OneDrive</div>
            }</>

            , customContentRender: () => {
                    return <OneDrveUsageChart userPeriod={Number(userPeriod)} />
            }

        },
        // //Caixas - ativas / uso
        {
            id: 5,
            type: 'Custom',
            showFocusButton: false,
            position: {
                ColSpan: 3, RowSpan: 5, row: 8, col:7
            },
            title: () => <>{
                <div className="lc-title ellipsis" title="Caixas - ativas / uso">Caixas - ativas / uso</div>
            }</>
            , customContentRender: (focused: boolean) => {
                return <EmailBoxesChart userPeriod={Number(userPeriod)} />
            }
        }
    ]



    const cards: Card[] = [
        //Usuários ativos / dia
        {
            id: 1,
            type: 'Custom',
            showFocusButton: false,
            bgColor: 'var(--color-primary-purple)',
            hideHeader: true,
            position: { ColSpan: 1, RowSpan: 10, row: 1, col: 1 },
            customContentRender: (focused: boolean) => {
                return <CustomNavPanel items={appsList} onItemClick={handleClickItem} defaultClickCard={defaultClickPanel}	/>
            }
        },
        {
            id: 2,
            type: 'Custom',
            showFocusButton: false,
            hideHeader: true,
            position: {  ColSpan: 9, RowSpan: 10, row: 1, col: 2 },
            bgColor:  'transparent' ,
            cssClass:  'notHover' ,
            customContentRender: () => {
                    return <LCDashboard
                        grid={[12,9]}
                        cards={principalCards}
                    />;
            }
        },
    ]

    return (
        <Layout
            pivot={pivotView}
            pageTitle="Atividades"
            periodSelection={periodSelection}
            // functionsGeneric={layoutFunctions}
        >
            <LCDashboard
                grid={[10,10]}
                cards={cards}
                // rightSidePanel={dashboardRightPanelAI}
            />
        </Layout>
    );
};

export default SaaSAtividades;